import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Notifications } from '../models/notification';
import { catchError, map, Observable } from 'rxjs';
import { ModalService } from '../../shared/services/modal.service';
import { SurveyResponse } from '../../shared/interfaces/survey-response';

@Injectable({ providedIn: 'root' })
export class NotificationsService {
  private API_URL = environment.apiUrl;
  private http = inject(HttpClient);
  private modalService = inject(ModalService);

  getNotifications(): Observable<Notifications[]> {
    return this.http.get<Notifications[]>(`${this.API_URL}/notifications`).pipe(
      map((response) => response),
      catchError((error: HttpErrorResponse) => {
        this.modalService.showErrorModal(error);
        throw error;
      }),
    );
  }

  markAsRead(notification: string) {
    return this.http
      .put<
        Notifications[]
      >(`${this.API_URL}/notifications/${notification}/read`, {})
      .pipe(
        map((response) => response),
        catchError((error: HttpErrorResponse) => {
          this.modalService.showErrorModal(error);
          throw error;
        }),
      );
  }

  getActiveSurvey(): Observable<SurveyResponse> {
    return this.http
      .get<SurveyResponse>(`${this.API_URL}/notifications/survey`)
      .pipe(
        map((response) => response),
        catchError((error: HttpErrorResponse) => {
          if (error.status !== 404) {
            this.modalService.showErrorModal(error);
          }
          throw error;
        }),
      );
  }

  completeSurvey(surveyId: number): Observable<void> {
    return this.http
      .post<void>(
        `${this.API_URL}/notifications/survey/${surveyId}/complete`,
        {},
      )
      .pipe(
        map((response) => response),
        catchError((error: HttpErrorResponse) => {
          this.modalService.showErrorModal(error);
          throw error;
        }),
      );
  }
}
